import React, { Component } from 'react';
import '../../Style/login.css';
import { connect } from 'react-redux';
import * as repositoryActions from '../../Store/Actions/repositoryActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class AVATableCol extends Component {
  constructor() {
    super();
    this.state = {
      expended:false,
      rowHover:0,
    };

  }

  onHoverRow=(rowNumber)=>{
    this.setState({rowHover:rowNumber});
  }

  createColumn= (data) => {
    var state = this.state;
    var cols = data.columns.map((column, i)=>{
      var cells = data.data.map((row,j)=>{
        var value = row[i].value;
        switch (column.type) {
          case "number":
            value = this.formatNumber(value);
            break;
          case "amount":
            // get devise(s), default EUR
            var devise = "EUR";
            if(data.columns.filter(columnTmp=>columnTmp.name.toLowerCase().includes("devise")).length>0){devise = data.columns.filter(columnTmp=>columnTmp.name.toLowerCase().includes("devise"))[0].data[0].value;}; 
            value = this.formatNumber(Number.parseFloat(value).toFixed(2))+ " "+devise;
            break;
          case "percent":
            value = this.formatNumber(Number.parseFloat(value).toFixed(2))+ " %";
            break;
          default:
            break;
        }

        return(
          <div 
            key={j} 
            title={"["+column.name +"] - "+value} 
            className={value.includes("-")?(row[i].rowNumber === state.rowHover ?"table-cell negative hover":"table-cell negative"):(row[i].rowNumber === state.rowHover ?"table-cell hover":"table-cell")} 
            onMouseOver={this.onHoverRow.bind(this,row[i].rowNumber)}
          >{value}</div>
        )
      })

      return(<div key={i} className={"table-col "+column.type}>
            <div onClick={this.props.sortHeader.bind(this,i)} className="table-header" onMouseOver={this.onHoverRow.bind(this,0)}>
                <div>{column.name}</div>
                <span>
                    {column.sort !== "" && column.sort !== null? (column.sort ==="up"? <FontAwesomeIcon icon="sort-amount-up" /> : <FontAwesomeIcon icon="sort-amount-down-alt" />):null}
                </span>
            </div>
            {cells}
      </div>)

    });


    return(
    <div className="table" onMouseOut={this.onHoverRow.bind(this,0)}>
          {cols}
    </div>
    )
  }


  formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
  }


  render() {
    var tcol = this.createColumn(this.props.data);
    return (
      <div className="table-container">
        {tcol}
      </div>
      
    );
  }
}

const mapStateToProps = (state) => {    
  return {  
    activeURI : state.appReducer.activeURI,
    activeData: state.appReducer.activeData,
    menuList: state.apiReducer.menuList,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
    updateActiveMenu: (uri) => dispatch(repositoryActions.updateActiveMenu(uri)),
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(AVATableCol);
